module.exports = "/static/assets/40a2d492cde1a89028a00bdd8ea74c24.png";